export default "__VITE_ASSET__e8326589__"